import { Injectable, inject } from '@angular/core';
import { CsvExport, ExcelExport } from '../../models/api/core/export/export';
import { Api } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  private api = inject(Api);


  async exportCsv(csvExport: CsvExport, filename: string): Promise<void> {
    const blob = await this.api.export.exportCsv(csvExport);
    this.downloadFile(blob, filename, 'text/csv');
  }

  async exportExcel(excelExport: ExcelExport, filename: string): Promise<void> {
    const blob = await this.api.export.exportExcel(excelExport);
    this.downloadFile(
      blob,
      filename,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
  }

  private downloadFile(blob: Blob, filename: string, mimeType: string): void {
    const file = new Blob([blob], { type: mimeType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(file);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  }
}
